import { VehicleOption } from 'models/auto/vehicle';
import { TravelDetailsVehicle } from 'models/travelDetails';
export const mapDetailsToVehicle = (details: TravelDetailsVehicle): VehicleOption => ({
  company: details.vehicleDetails.company,
  vehicle: details.vehicleDetails.vehicle,
  pickUp: details.vehicleDetails.pickUp,
  dropOff: details.vehicleDetails.dropOff,
  breakRulesMessage: details.breakRulesMessage,
});
